import { ScheduleGraphQL } from '@mod/schedule';

const appointmentEventFragmentBodyProp = Object.getOwnPropertyDescriptor(
  ScheduleGraphQL,
  'AppointmentEventFragmentBody',
)!;

Object.defineProperty(ScheduleGraphQL, 'AppointmentEventFragmentBody', {
  get: () => {
    return `
      ${appointmentEventFragmentBodyProp.get!()}
      title

      encounter {
        id
      }
    `;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentAgendaEventFragmentExtraBody', {
  get: () => {
    return `
      title

      encounter {
        id
      }
    `;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentSummaryEventFragmentExtraBody', {
  get: () => {
    return `
      title

      encounter {
        id
      }
    `;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentEventHostFragmentBody', {
  get: () => {
    return `
      id
      firstName
      lastName
      email
      avatar
      active`;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentEventVisitorFragmentBody', {
  get: () => {
    return `
      id
      firstName
      lastName
      status
      address {
        street
        city
        region
        country
        zipCode
        line2
      }
      careHome {
        id
        name
        address {
          street
          city
          region
          country
          zipCode
          line2
        }
      }`;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentRequestVisitorRefFragmentBody', {
  get: () => {
    return `
      id
      firstName
      lastName
      status
      address {
        street
        city
        region
        country
        zipCode
        line2
      }
      careHome {
        id
        name
        type
        address {
          street
          city
          region
          country
          zipCode
          line2
        }
      }
    `;
  },
});

Object.defineProperty(ScheduleGraphQL, 'AppointmentRequestAppointmentTypeFragmentBody', {
  get: () => {
    return `id name durationInMinutes`;
  },
});

// Cast to avoid readonly/type-mismatch during runtime augmentation
ScheduleGraphQL.AppointmentEventBaseCareHomeFragmentBody = () => `
  id
  type
  name
`;
